import { render, staticRenderFns } from "./orderDetailInfo.vue?vue&type=template&id=b54866b0&"
import script from "./orderDetailInfo.vue?vue&type=script&lang=js&"
export * from "./orderDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailInfo.vue?vue&type=style&index=0&id=b54866b0&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports